"use client";

import { useEffect, useRef, useState } from "react";
import { handleDropdownClose } from "../../utils/utils";

const SearchDropdown = ({
  text,
  placeholder,
  options,
  handleSelect,
  fetchSuggestions,
  onSetOptions,
  handleKeyDown,
  onChange,
  isTop = false,
  closeDropdown, // ✅ NEW PROP (controlled close)
}) => {
  const dropdownRef = useRef(null);

  const [input, setInput] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  // Sync input with parent
  useEffect(() => {
    setInput(text || "");
  }, [text]);

  // ✅ Controlled close from parent
  useEffect(() => {
    if (closeDropdown) {
      setIsFocused(false);
      onSetOptions([]);
    }
  }, [closeDropdown]);

  // Close on outside click
  useEffect(() => {
    const handleClose = () => {
      setIsFocused(false);
      onSetOptions([]);
    };

    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  // Debounce API
  useEffect(() => {
    if (!input || !isFocused) {
      onSetOptions([]);
      return;
    }

    const timer = setTimeout(() => {
      fetchSuggestions(input);
    }, 400);

    return () => clearTimeout(timer);
  }, [input, isFocused]);

  // ✅ Handle select (NO AUTO CLOSE)
  const handleOptionClick = (option) => {
    handleSelect(option);
    setInput(option.label);

    // ❌ REMOVED:
    // setIsFocused(false);
    // onSetOptions([]);
  };

  return (
    <div ref={dropdownRef}>
      <div className="relative">
        <input
          type="text"
          placeholder={placeholder}
          value={input}
          onFocus={() => setIsFocused(true)}
          onChange={(e) => {
            setInput(e.target.value);
             onChange?.(e);
          }}
          onKeyDown={handleKeyDown}
          className="body-N mt-0 dark-H w-full h-[40px] rounded-[6px] focus:outline-none"
        />

        {isFocused && options?.length > 0 && (
          <div
            className={`absolute ${isTop ? "bottom-10" : ""
              } z-10 w-full mt-1 light-bg-L border border-gray-300 rounded-md shadow-md max-h-[40vh] overflow-y-auto`}
          >
            {options.map((option) => (
              <div
                key={option.value}
                className="px-3 py-2 body-N hover:bg-gray-100 dark-H cursor-pointer"
                onMouseDown={() => handleOptionClick(option)}
              >
                {option.label}
                {option?.desc && (
                  <p className="body-S dark-M">{option.desc}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchDropdown;